import { autoinject, customAttribute } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';

@autoinject
@customAttribute('af-attached')
export class AttachedCustomAttribute {
  @bindable onAttached: (args: AttachedEventArgs) => void;
  @bindable onDetached: (args: AttachedEventArgs) => void;

  constructor(private element: Element) { }

  attached() {
    if (this.onAttached)
      this.onAttached({ element: this.element });
  }

  detached() {
    if (this.onDetached)
      this.onDetached({ element: this.element });
  }
}

export interface AttachedEventArgs { element: Element };
